import { render, staticRenderFns } from "./JobOfferCategories.vue?vue&type=template&id=bf7e19a8&scoped=true&"
import script from "./JobOfferCategories.vue?vue&type=script&lang=js&"
export * from "./JobOfferCategories.vue?vue&type=script&lang=js&"
import style0 from "./JobOfferCategories.vue?vue&type=style&index=0&id=bf7e19a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7e19a8",
  null
  
)

export default component.exports